import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Pattern } from '@app/shared/validators/pattern';
import { AddressService } from '@app/shared/services/address/address.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { MatchPassword } from '@app/shared/validators/passwordmatch';
import { CommonService } from '@app/shared/services/common/common.service';
import { UploadImageDialogComponent } from '@app/shared/components/upload-image-dialog/upload-image-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from '@app/shared/services/common/message.service';
import { Browser } from 'protractor';
import { LazyloadjsService } from '@app/shared/services/lazyloadjs/lazyloadjs.service';
import { DOCUMENT } from '@angular/common';
import { BraintreeService } from '@app/shared/services/braintree/braintree.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WelcomeScreenComponent } from '@app/feature/store-admin/components/welcome-screen/welcome-screen.component';
import { PopupIframeComponent } from '@app/shared/components/popup-iframe/popup-iframe.component';

import { strictEqual } from 'assert';
import { DeleteAccountConfirmationComponent } from '../delete-account-confirmation/delete-account-confirmation.component';
// import { load } from '@angular/core/src/render3/instructions';
import { UserService } from '../../../../shared/services/user/user.service';
interface ResponseApi {
  StatusCode: number;
  Message: string;
}

@Component({
  selector: 'app-storeadmin-profile',
  templateUrl: './storeadmin-profile.component.html',
  styleUrls: ['./storeadmin-profile.component.css']
})
export class StoreadminProfileComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private router: Router, private loader: LoaderService,
    private notificationService: NotificationService,
    private addressService: AddressService, private messageService: MessageService,
    private dialog: MatDialog,
    private brainTreeService: BraintreeService,
    private readonly svc: LazyloadjsService,
    @Inject(DOCUMENT) private readonly document: any,
    private sanitizer: DomSanitizer, private userService: UserService) {

    this.UserId = localStorage.getItem('userId');
    this.forceChangePassword = localStorage.getItem('ForceChangePassword') == "true" ? true : false;
    this.editStoreAdminProfileForm = this.formBuilder.group({
      FirstName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      LastName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      PhoneNumber: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CONTACT_NO_PATTERN),
      Validators.minLength(10), Validators.maxLength(10)])),
      CustomerAccountNumber: [''],
      Email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.EMAIL_PATTERN)])),
      AddressLine: new FormControl(''),
      ZipCode: new FormControl(''),
      StateId: new FormControl(''),
      CountryId: new FormControl(''),
      City: new FormControl(''),
      LandMark: new FormControl(''),
      UserName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.EMAIL_PATTERN)])),
      ProfileImage: [''],
      Facebook_pixel: new FormControl(''),
      Account_HolderName: new FormControl(''),
      Account_Number: new FormControl(''),
      Bank_Name: new FormControl(''),
      Google_code: new FormControl(''),
      SSN_No: new FormControl('',),
      EIN_No: new FormControl('',),
      Bank_Location: new FormControl(''),
      // PayPal_AccHolderName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      // PayPal_EmailAddress: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.EMAIL_PATTERN)])),
      PayPal_AccHolderName: new FormControl(''),
      PayPal_EmailAddress: new FormControl(''),
      UserId: [this.UserId],
      ModifiedBy: [this.UserId],
      CurrentPassword: [''],
      Password: [''],
      ConfirmPassword: ['']
    }, {
      // validator: MatchPassword.MatchPassword.bind(this)
      validator: MatchPassword.MatchPassword
    });

  }

  // convenience getter for easy access to form fields
  get f() {
    return this.editStoreAdminProfileForm.controls;
  }
  editStoreAdminProfileForm: FormGroup;
  UserId: any;
  forceChangePassword: boolean = false;
  public edited = true;
  public corporateEdited = false;
  public SSN_Value: any;
  public EIN_Value: any;
  imageSrc !: any;
  countries !: any[];
  states !: any[];
  private configBrainTree: { env: string; token: string; };

  pdfw9 = '';

  sanitize(url: string) {
    // return url;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  ngOnInit() {

    this.getCountries();
    this.getStoreAdminProfileById(this.UserId);
  }

  LoadPaypalAndBrainTreeLib() {
    this.svc.lazyLoadPaypalAndBrainTree().subscribe(useless => {
      this.initConfigPaypalAndBrainTree();
    });
  }

  initConfigPaypalAndBrainTree() {
    const config = this.configBrainTree;
    const brainTree = this.brainTreeService;
    const UserId = this.UserId;
    const notif = this.notificationService;
    // @ts-ignore
    window.braintree.client.create({
      authorization: config.token
    }, function (clientErr: any, clientInstance: any) {

      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      // Create a PayPal Checkout component.
      // @ts-ignore
      window.braintree.paypalCheckout.create({
        client: clientInstance
      }, function (paypalCheckoutErr: any, paypalCheckoutInstance: any) {

        // Stop if there was a problem creating PayPal Checkout.
        // This could happen if there was a network error or if it's incorrectly
        // configured.
        if (paypalCheckoutErr) {
          console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
          return;
        }

        // Set up PayPal with the checkout.js library
        // @ts-ignore
        window.paypal.Button.render({
          env: config.env, // or 'sandbox'
          style: {
            size: 'medium',
            color: 'blue',
            shape: 'rect',
            label: 'pay',
            tagline: 'false'
          },
          payment: function () {
            return paypalCheckoutInstance.createPayment({
              flow: 'vault',
              billingAgreementDescription: 'Authorize automatic payments for shopify order',
              enableShippingAddress: false
            });
          },

          onAuthorize: function (data: any, actions: any) {
            return paypalCheckoutInstance.tokenizePayment(data, function (err: any, payload: any) {
              // Submit `payload.nonce` to your server.
          
              
              brainTree.submitNonce({               
                nonce: payload.nonce,
                userid: UserId,
                paypalEmail: payload.details.email,
                paypalFirstName: payload.details.firstName,
                paypalLastName: payload.details.lastName
              }).subscribe((res: any) => {
                // tslint:disable-next-line:no-shadowed-variable
                const data: ResponseApi = res;
                if (data.StatusCode === 200) {
                  notif.success('Successfully connected with paypal', 'Connected');
                } else {
                  notif.error(data.Message, 'Error');
                }
              });
            });
          },

          onCancel: function (data: any) {
            console.log('checkout.js payment cancelled');
          },

          onError: function (err: any) {
            console.error('checkout.js error', err);
          }
        }, '#paypal-button').then(function () {       
          // The PayPal button will be rendered in an html element with the id
          // `paypal-button`. This function will be called when the PayPal button
          // is set up and ready to be used.
        });

      });

    });
  }

  Taxable(val: 0, form: FormGroup) {
    this.SSN_Value = 0;
    this.EIN_Value = 0;
    this.edited = false;
    this.corporateEdited = false;
    form.get('SSN_No').clearValidators();
    form.get('SSN_No').updateValueAndValidity();
    form.get('EIN_No').clearValidators();
    form.get('EIN_No').updateValueAndValidity();
  }

  UserDetailsToForm(dataObj: any, storeAdminId: number) {
    if (dataObj.AddressInfo) {
      dataObj = { ...dataObj, ...dataObj.AddressInfo };
    }
    if (dataObj.StoreOwnerAccInfoModel) {
      dataObj = { ...dataObj, ...dataObj.StoreOwnerAccInfoModel };
    }
    const emptyObj = this.editStoreAdminProfileForm.getRawValue();
    Object.keys(emptyObj).forEach(value => {
      if (dataObj[value]) {
        emptyObj[value] = dataObj[value];
      } else {
        emptyObj[value] = '';
      }
    });
    emptyObj.CountryId = emptyObj.CountryId.toString();
    emptyObj.StateId = emptyObj.StateId.toString();
    emptyObj.UserId = storeAdminId;
    emptyObj.CurrentPassword = '';
    emptyObj.Password = '';
    emptyObj.ConfirmPassword = '';
    emptyObj.ModifiedBy = storeAdminId;
    return emptyObj;
  }


  /** Gets store data by storeid */
  getStoreAdminProfileById(storeAdminId: number) {
    this.loader.show();
    this.addressService.getStoreAdminById(storeAdminId).subscribe((res) => {
      this.getStatesByCountry(res.Data.ResponseData.AddressInfo !== null &&
        (res.Data.ResponseData.AddressInfo.CountryId !== null || res.Data.ResponseData.AddressInfo.CountryId !== 0) ?
        res.Data.ResponseData.AddressInfo.CountryId : 0);
      this.pdfw9 = res.Data.ResponseData.pdfw9;
      this.editStoreAdminProfileForm.setValue(this.UserDetailsToForm(res.Data.ResponseData, storeAdminId));
      this.Taxable(0, this.editStoreAdminProfileForm);
      this.configBrainTree = {
        env: res.Data.ResponseData.brainTreeConfig.env.toLowerCase(),
        token: res.Data.ResponseData.brainTreeConfig.clientToken
      };
      this.LoadPaypalAndBrainTreeLib();
      this.imageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
      this.loader.hide();
    }, err => {
      if (err.status == 401) {
        this.notificationService.error('Please login again', 'Session expired');
        this.router.navigate(['/']);
      } else {
        this.notificationService.error('An error occured', 'Error');
        this.loader.hide();
      }

    });
  }

  /** Update profile data */
  UpdateStoreAdminProfile(form: FormGroup) {
    if (this.SSN_Value === 0 && this.EIN_Value === 0) {
      form.value.SSN_No = null;
      form.value.EIN_No = null;
      if (form.value.CountryId == "")
        form.value.CountryId = "0";
      if (form.value.StateId == "")
        form.value.StateId = "0";
    }
    form.value.pdfw9 = this.pdfw9;
    this.loader.show();
    this.addressService.updateStoreAdminProfile(form.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if(form.value.Password != ''){
          localStorage.removeItem('ForceChangePassword');
          this.forceChangePassword = false;
        }
        this.notificationService.success(res.Message, 'Profile');
        window.localStorage.setItem('profileImage', res.Data.LoginResponseModel.ProfileImage !== 'null' ?
          res.Data.LoginResponseModel.ProfileImage : 'assets/img/default_user_img.png'),
          window.localStorage.setItem('profileName', res.Data.LoginResponseModel.FullName !== 'null' ?
            res.Data.LoginResponseModel.FullName : ''),
          this.editStoreAdminProfileForm.patchValue({
            CurrentPassword: '',
            Password: '',
            ConfirmPassword: '',
          });
        this.imageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
        const r = {
          profileImage: res.Data.LoginResponseModel.ProfileImage !== 'null' ?
            res.Data.LoginResponseModel.ProfileImage : 'assets/img/default_user_img.png',
          profileName: res.Data.LoginResponseModel.FullName
        };
        this.messageService.sendMessage(r);
      } else if (res.StatusCode === 400) {
        this.notificationService.error(res.Message, 'Try again');
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
      }
      this.loader.hide();
    }, err => {
      this.notificationService.error('An error occured', 'Error');
      this.loader.hide();
    });
  }

  /** Get all countries */

  getCountries() {
    this.addressService.getCountries().subscribe((res: any) => {
      this.countries = res.Data.ResponseData;
    }, err => {
    });
  }

  /** Get states by country */
  getStatesByCountry(event: any) {
    if (event !== null && event !== 0) {
      this.loader.show();
      this.addressService.getStatesByCountry(event).subscribe((res: any) => {
        this.states = res.Data.ResponseData;
        this.loader.hide();
      }, err => {
        this.loader.hide();
      });
    }
  }

  openUploadImageDialog(): void {
    const dialog = this.dialog.open(UploadImageDialogComponent, {
      disableClose: true,
      width: '550px',
      data: this.imageSrc
    });
    dialog.afterClosed().subscribe((res: any) => {
      if (res !== 'false') {
        this.imageSrc = res;
        this.editStoreAdminProfileForm.patchValue({
          ProfileImage: res
        });
      }
    });
  }

  fn_deleteAccount() {
    const dialog = this.dialog.open(DeleteAccountConfirmationComponent, {
      disableClose: true,
      width: '550px',
      data: localStorage.getItem('userId'),
    })
    dialog.afterClosed().subscribe((res: any) => {
      if (res != "" && res != null && res != "false") {
        this.loader.show();
        this.addressService.deletedUserQuestionare(Number(localStorage.getItem('userId')), res).subscribe((data: any) => {
          if (data.StatusCode == 200) {
            this.notificationService.success("Your account has been deactivated successfully!", "Success");
            localStorage.clear();
            this.router.navigate(['']);
          }
          else {
            this.notificationService.error("Some error occured, please try again later!", "Error");
          }
          this.loader.hide();
        })
      }
    });
  }
}
